const stripLeadingAndTrailing = (str = '', char) => {
  if (!char) {
    throw new Error('char parameter is required');
  }
  const regex = new RegExp(`^${char}+|${char}+$`, 'g');
  return str.replace(regex, '');
};

/**
 * Build absolute urls that always start with a slash and omit trailing slash.
 * (Exception: 'http' at start is retained.)
 * Slashes between parts are trimmed or added when necessary.
 * @param parts Url parts (string)
 * @returns {*|string}
 */
const buildUrl = (...parts) => {
  const ret = parts
    .filter(x => !!x)
    .reduce(
      (prev, curr) => prev + '/' + stripLeadingAndTrailing(String(curr), '/'),
      ''
    );
  if (ret.startsWith('/http')) {
    return ret.substring(1);
  }
  return ret;
};

export default buildUrl;
